/* Cash Management Client barrel export */

import { CashManagementClientMocked } from './cashManagementClientMocked';

// Re-export types
export * from './cashManagementTypes';

// Cash Management has no real backend yet — always use the in-code mocked client.
const cashManagementClient = new CashManagementClientMocked();

/** @deprecated Use cashManagementClient directly */
export const getCashManagementClient = () => cashManagementClient;

export { cashManagementClient };
export type { ICashManagementClient } from './ICashManagementClient';
